import { axiosApi as axios } from '../helpers/axiosApi';
import { getCookie } from './helpers';
const LINKS_API = "/studies/links/";

export const getLinks = (params) => {
  return axios.get(LINKS_API, {params: params}).then(res => res.data);
}

export const addLink = (link) => {
  return axios.post(LINKS_API, link, {
    headers: {
      "Authorization": `Bearer ${getCookie('access')}`
    }
  }).then(res => {
    return res.data;
  })
}

export const updateLink = (link, id) => {
  return axios.put(`${LINKS_API}${id}/`, link, {
    headers: {
      "Authorization": `Bearer ${getCookie('access')}`
    }
  }).then(res => {
    return res.data;
  })
}

export const deleteLink = (id) => {
  return axios.delete(`${LINKS_API}${id}/`, {
    headers: {
      "Authorization": `Bearer ${getCookie('access')}`
    }
  }).then(res => {
    return res;
  })
}
